<div class="astral-stack-l">
  <h2>{{ 'BUILDING_SPACE.ADD_BUILDING_SPACE' | translate }}</h2>
  @if (form) {
    <form class="astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
        <astral-select
          [span]="'full'"
          [control]="form.controls['buildingSpaceTypeId']"
          [itemsSource]="buildingSpaceTypes"
        ></astral-select>
        <astral-input [span]="'full'" [control]="form.controls['caption']"></astral-input>
        <astral-input [control]="form.controls['spaceNumber']"></astral-input>
        <astral-input type="number" [control]="form.controls['area']"></astral-input>
      </astral-layout-group>
      <div class="astral-form-actions">
        <astral-button variant="primary" type="submit" labelKey="SAVE_BTN"></astral-button>
        <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
      </div>
    </form>
  }
</div>
